/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class StatisticsService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'StatisticsService\' loaded');
    }

    /**
     * Request metrics.
     *
     * @param {Object} data Data sent in the request body.
     * @returns {Promise} A promise providing the metrics.
     */
    getMetrics(data) {
        return this.resource.metrics(undefined, data).$promise;
    }

    /**
     * Request chart data.
     *
     * @param {String} type Type of chart.
     * @param {Object} data Data sent in the request body.
     * @returns {Promise} A promise providing the chart data.
     */
    getChartData(type, data) {
        return this.resource.chartData({type}, data).$promise;
    }
}

export { StatisticsService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/service/StatisticsService.js